import { make } from 'vuex-pathify'
import store from '../index'
import { getQueryFromFilter, showError, showSuccess } from '@/util/helpers'
import { formatDate } from '@/util/formatters'
import axios from 'axios'

const state = {
  schedule: {
    users: [],
  },
  schedules: {
    data: [],
    count: 0,
    limit: 50,
  },

  filter: {
    startDate: '',
    endDate: '',
  },

  type: 'add',
  loading: false,
  dialog: false,
}

const mutations = make.mutations(state)

const actions = {
  add: ({ state }) => {
    state.schedule = {
      users: [],
      allDay: true,
      companyId: store.get('authStore@currentCompany').id,
    }
    state.type = 'add'
    state.dialog = true

    state.schedule.users.push(store.get('authStore@currentUser').id)

    store.dispatch('scheduleStore/loadCombos')
  },

  edit: ({ state }, id) => {
    state.loading = true
    store.dispatch('scheduleStore/getById', id)
      .then(res => {
        state.schedule = res.data

        state.type = 'edit'
        state.dialog = true

        // format data
        state.schedule.date = formatDate(new Date(res.data.date).toISOString().substr(0, 10))

        store.dispatch('scheduleStore/loadCombos')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  loadCombos: async () => {
    store.dispatch('userStore/get', {
      page: 1,
      itemsPerPage: 10000,
      type: 1,
      sortBy: ['name'],
      sortDesc: ['desc'],
    })

    store.dispatch('customerStore/get', {
      page: 1,
      itemsPerPage: 10000,
      sortBy: ['name'],
      sortDesc: [false],
    })
  },

  save: ({ state }, schedule) => {
    const id = schedule.id
    const method = id ? 'put' : 'post'

    state.loading = true
    return axios[method](`${process.env.VUE_APP_API_URL}/schedule/${id || ''}`, schedule)
      .then((res) => {
        state.dialog = false
        store.dispatch('scheduleStore/get')
        showSuccess('Agendamento salvo com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  get: async ({ state }, filter = state.filter) => {
    const user = store.get('authStore@currentUser')
    filter.userId = user.id

    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/schedule?${getQueryFromFilter(filter)}`)
      .then(res => {
        state.schedules = res.data

        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  getById: (context, id) => axios.get(`${process.env.VUE_APP_API_URL}/schedule/${id}`).catch(showError),

  remove: ({ state }, id) => {
    state.loading = true
    return axios.delete(`${process.env.VUE_APP_API_URL}/schedule/${id}`)
      .then(_ => {
        store.dispatch('scheduleStore/get')
        showSuccess('Agendamento excluído com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
